import { Assunto } from "./assunto.model";
import { Ato } from "./ato.model";
import { SegmentoTela } from "./segmento.model";

export class AtoComparacao {
    ato: Ato;
    idAtoOriginalRepublicacao: number;
    assunto: Assunto;
    conteudoAtoOriginal: string;
    segmentosCarregados: boolean;
    segmentosTela: SegmentoTela[];
}